import ReactDOM from 'react-dom'

import { lifecycle } from 'recompose'

type HandlerProps = {
  handleOutside: (event: Event) => void
  toggleListeners: (on: boolean) => void
}

export default (handler, eventName = 'click') =>
  lifecycle<{}, {}, HandlerProps>({
    componentDidMount() {
      this.handleOutside = this.handleOutside.bind(this)

      this.toggleListeners(true)
    },

    componentWillUnmount() {
      this.toggleListeners(false)
    },

    handleOutside(event) {
      // If no focus target is provided, we'll use this HOC as a way to locate the element
      const component = this.props.focusTarget || this

      // Disabling ESLint for this line for no reason other than the code existed like this before this ESLint rule went into effect.
      // If you're here from the future, please resolve this ESLint error!
      // eslint-disable-next-line react/no-find-dom-node
      if (!ReactDOM.findDOMNode(component).contains(event.target)) {
        handler(this.props)
      }
    },

    toggleListeners(on) {
      const method = on ? 'addEventListener' : ('removeEventListener' as any)

      document[method](eventName, this.handleOutside, true)
    },
  })
